import React from "react";
import Card from "react-bootstrap/Card";
import "./ProjectCard.css";

const ProjectCard = ({ img, title, tech, code, live, backend }) => {
  return (
    <>
      <Card key={title} className="p-3">
        <div className="img-container">
          <Card.Img variant="top" src={img} />
          <div className="overlay">
            {/* <a className="link" href="#">
              Link1
            </a> */}
            <a target="_blank" rel="noreferrer" className="link" href={code}>
              Source Code
            </a>
            <a target="_blank" rel="noreferrer" className="link" href={live}>
              Live Site
            </a>
            {backend && (
              <a
                target="_blank"
                rel="noreferrer"
                className="link"
                href={backend}
              >
                Backend
              </a>
            )}
          </div>
        </div>
        <Card.Body className="py-3 px-0">
          <Card.Title>{title}</Card.Title>
          {tech && tech.map((item) => <span className="me-2 tag">{item}</span>)}
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
      </Card>
    </>
  );
};

export default ProjectCard;
